import React from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Geçici Placeholder Ekranı
 * TableOrderScreen.tsx yerine gösterilir
 * Masa sipariş alma ekranı yapım aşamasında
 */
const TableOrderScreenPlaceholder: React.FC = () => {
  const navigate = useNavigate();
  const { setupId, tableId } = useParams<{ setupId: string; tableId: string }>();

  const handleGoBack = () => {
    if (setupId) {
      navigate(`/restaurant-screen/${setupId}`);
    } else {
      navigate('/restaurant-management');
    }
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100vh', 
        bgcolor: '#f5f5f5',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Container maxWidth="md">
        <Paper 
          elevation={3} 
          sx={{ 
            p: 6, 
            textAlign: 'center',
            borderRadius: 3,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white'
          }}
        >
          <Box sx={{ mb: 3 }}>
            <ConstructionIcon sx={{ fontSize: 100, color: 'warning.light', animation: 'pulse 2s infinite' }} />
          </Box>
          
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Yapım Aşamasında
          </Typography>
          
          <Typography variant="h5" sx={{ mb: 3, opacity: 0.9 }}>
            Bu Ekran Şu Anda Geliştiriliyor
          </Typography>
          
          <Alert 
            severity="info" 
            sx={{ 
              mb: 4, 
              bgcolor: 'rgba(255, 255, 255, 0.2)', 
              color: 'white',
              '& .MuiAlert-icon': { color: 'white' }
            }}
          >
            <Typography variant="body1" sx={{ textAlign: 'left' }}>
              <strong>Masa Sipariş Alma Ekranı</strong> yeniden tasarlanıyor.
              <br />
              <br />
              <strong>Geliştirmeler:</strong>
              <br />
              • Hızlı Satış sistemi entegrasyonu
              <br />
              • Yeni UI/UX iyileştirmeleri
              <br />
              • Performans optimizasyonları
            </Typography>
          </Alert>

          {tableId && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" sx={{ opacity: 0.8 }}>
                Seçilen Masa: <strong>Masa {tableId}</strong>
              </Typography>
            </Box>
          )}

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<ArrowBackIcon />}
              onClick={handleGoBack}
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                fontWeight: 'bold',
                px: 4,
                py: 1.5,
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                  transform: 'translateY(-2px)',
                  boxShadow: 6
                },
                transition: 'all 0.3s'
              }}
            >
              Masalara Geri Dön
            </Button>
          </Box>

          <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <CircularProgress size={20} sx={{ color: 'white' }} />
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              Yeni versiyon yakında aktif olacak...
            </Typography>
          </Box>
        </Paper>
      </Container>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
            }
            50% {
              opacity: 0.7;
              transform: scale(1.05);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default TableOrderScreenPlaceholder;

